import React, { FC } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { EmployeeDistributionData } from "../../hooks";

import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@components/base";
import { DonutChart } from "@components/common/charts";

interface PaygapEmployeeDistributionProps {
  employeeDistributionData: EmployeeDistributionData[];
}

const PaygapEmployeeDistribution: FC<PaygapEmployeeDistributionProps> = ({
  employeeDistributionData,
}) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {t("paygap.analysis.employeeDistribution.title")}
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    {t("paygap.analysis.employeeDistribution.gender")}
                  </TableCell>
                  <TableCell align="right">
                    {t("paygap.analysis.employeeDistribution.totalHeadcount")}
                  </TableCell>
                  <TableCell align="right">
                    {t("paygap.analysis.employeeDistribution.monthlyContracts")}
                  </TableCell>
                  <TableCell align="right">
                    {t("paygap.analysis.employeeDistribution.hourlyContracts")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {employeeDistributionData.map((row) => (
                  <TableRow key={row.gender}>
                    <TableCell>
                      {row.gender === "Total"
                        ? t("paygap.analysis.employeeDistribution.total")
                        : row.gender}
                    </TableCell>
                    <TableCell align="right">{row.totalHeadcount}</TableCell>
                    <TableCell align="right">{row.monthlyContracts}</TableCell>
                    <TableCell align="right">{row.hourlyContracts}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box id="paygap-employee-distribution-donut" display="flex" justifyContent="center">
              <DonutChart
                data={[
                  {
                    label: `${t("paygap.graph.men")}: ${((employeeDistributionData[0].totalHeadcount / employeeDistributionData[2].totalHeadcount) * 100).toFixed(1)}% (${employeeDistributionData[0].totalHeadcount}): ${((employeeDistributionData[0].totalHeadcount / employeeDistributionData[2].totalHeadcount) * 100).toFixed(1)}%`,
                    value:
                      (employeeDistributionData[0].totalHeadcount /
                        employeeDistributionData[2].totalHeadcount) *
                      100,
                    color: "#2196f3",
                  },
                  {
                    label: `${t("paygap.graph.women")}: ${((employeeDistributionData[1].totalHeadcount / employeeDistributionData[2].totalHeadcount) * 100).toFixed(1)}% (${employeeDistributionData[1].totalHeadcount}): ${((employeeDistributionData[1].totalHeadcount / employeeDistributionData[2].totalHeadcount) * 100).toFixed(1)}%`,
                    value:
                      (employeeDistributionData[1].totalHeadcount /
                        employeeDistributionData[2].totalHeadcount) *
                      100,
                    color: "#9c27b0",
                  },
                ]}
                title={`${t("paygap.analysis.employeeDistribution.total")} ${employeeDistributionData[2].totalHeadcount}`}
                size={130}
                strokeWidth={15}
              />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default PaygapEmployeeDistribution;
